import React from 'react'
import { useNavigate } from 'react-router-dom';
import { signIn } from '../../../utils/router/constant';
import Button from '../../../components/common/button';
import { SuccessIcon } from '../../../assets/images/svg/svg';

const Success = () => {
    const navigate = useNavigate();
    return (
        <div className="auth--form--wrapper">
            <h1 className="auth--title">Success!</h1>
            <p className="auth--subtitle">
                You’ve Successfully Signed Up
            </p>
            <div className="signUp--success--icon">
                <SuccessIcon />
            </div>
            <div className='signUp--success--btn'>
                <Button
                    type="button"
                    variant="primary"
                    label="Continue"
                    onClick={() => navigate(signIn)}
                />
            </div>
        </div>
    )
}

export default Success;